module.exports = __webpack_public_path__ + "static/img/Receive3.c0d68b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Receive3.png
// module id = tVOE
// module chunks = 0